<div class="flex flex-col items-center gap-4 p-4">
  <h3>Select a Workspace</h3>
  <mat-form-field class="w-80">
    <input
      matInput
      placeholder="Search Workspaces"
      [formControl]="searchCtrl"
      [matAutocomplete]="auto"
      (keyup.enter)="selectFirstOption()"
    />
    <mat-autocomplete #auto="matAutocomplete">
      @for (
        workspace of workspaceSearch.results$ | async;
        track workspace.uid
      ) {
        <mat-option
          [value]="workspace"
          (click)="workspaceSelected.emit(workspace)"
        >
          <div class="flex max-w-[290px] flex-col overflow-hidden py-2">
            <span class="truncate font-medium">{{
              workspace.name || workspace.workspace
            }}</span>
            @if (workspace.name) {
              <span class="truncate text-xs text-slate-400">{{
                workspace.workspace
              }}</span>
            }
          </div>
        </mat-option>
      }
    </mat-autocomplete>
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>
